import Axios from 'axios'

const BASE_URL = window.location.origin;

const actions = {
  getSchedule: ({commit}) => {
    Axios.get(BASE_URL + '/local/api/schedule/courses.php', { headers: { 'Api': 'enabled' } })
      .then(response => {
        commit("SET_SCHEDULE", {
          type: 'list',
          val: Object.freeze(response.data)
        });
      })
      .catch((error) => {
        commit("SET_SCHEDULE", {type: 'error', val: true});
        new Error(error);
      })
      .finally(() =>
        commit("SET_SCHEDULE", {type: 'loading', val: false})
      );
  },
  getStartAvailableDate: ({commit}) => {
    Axios.get(BASE_URL + '/local/api/schedule/dates.php', { headers: { 'Api': 'enabled' } })
      .then(response => {
        const dateNow = new Date();
        const dateNowMs = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate()).getTime() + dateNow.getTimezoneOffset() * 60000;
        commit("SET_START_AVAILABLE_DATE", {
          type: 'list',
          val: response.data.filter(item => parseDateUniversal(item) >= dateNowMs)
        });
      })
      .catch((error) => {
        commit("SET_START_AVAILABLE_DATE", {type: 'error', val: true});
        new Error(error);
      })
      .finally(() =>
        commit("SET_START_AVAILABLE_DATE", {type: 'loading', val: false})
      );
  },
  getAddress: ({commit}) => {
    Axios.get(BASE_URL + '/local/api/schedule/addresses.php', { headers: { 'Api': 'enabled' } })
      .then(response => {
        commit("SET_ADDRESS", {
          type: 'list',
          val: response.data
        });
      })
      .catch((error) => {
        commit("SET_ADDRESS", {type: 'error', val: true});
        new Error(error);
      })
      .finally(() =>
        commit("SET_ADDRESS", {type: 'loading', val: false})
      );
  },

  setFilterDateModel: ({commit}, payload) => {
    commit("SET_FILTER_DATE_MODEL", payload);
  },
  setFilterAddressModel: ({commit}, payload) => {
    commit("SET_FILTER_ADDRESS_MODEL", payload);
  },
  setFilterSearchURL: ({commit}, payload) => {
    commit("SET_FILTER_SEARCH_MODEL", payload);
  },
  setURL: ({commit}, payload) => {
    commit("SET_URL", payload);
  },
  setAvailableDate: ({commit}, payload) => {
    commit("SET_AVAILABLE_DATE", payload);
  }
};

export default {
  ...actions
}
function parseDateUniversal (dateStr) {
  const date = new Date(dateStr.slice(0, 10))
  const dateTime = date.getTime()
  const dateTimeZone = date.getTimezoneOffset() * 60000
  return dateTime + dateTimeZone
}